import * as React from "react";
import { useSelector } from "react-redux";

import MainDashboard from "../../components/Dashboard/MainDashboard";
import VTDashboard from "../../components/Dashboard/VTDashboard";

const DashboardRouter = () => {
  const { isVoiceTalent } = useSelector(({ user }) => user.user);

  React.useEffect(() => {
    sessionStorage.removeItem("aoede:selectedTab");
  });

  return isVoiceTalent ? <VTDashboard /> : <MainDashboard />;
};

export default DashboardRouter;
